/* eslint-disable linebreak-style */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/jsx-filename-extension */
import React, { useState, useEffect } from 'react';
import { DiscussForm } from 'parts/DiscussForm';

import Header from 'parts/Header';
import Footer from 'parts/Footer';

const initialData = {
  name: '',
  email: '',
  role: '',
  message: '',
};

export const DiscussProjectPage = () => {
  const [data, setData] = useState(initialData);

  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  const onChange = (event) => {
    setData((prevData) => ({
      ...prevData,
      [event.target.name]: event.target.value,
    }));
  };

  const resetForm = () => {
    setData(initialData);
  };

  return (
    <>
      <Header />
      <main id="main">
        <DiscussForm data={data} onChange={onChange} resetForm={resetForm} />
      </main>
      <Footer />
    </>
  );
};
